import { SET_SELECTED_ADDRESS } from 'redux/modules/slot-booking/actions/types';

import * as selectedSlotActions from './selected-address-actions';

export default {
  [SET_SELECTED_ADDRESS]: selectedSlotActions.selectedAddress,
};
